import { ArrowDown, ArrowUp } from "lucide-react";
import * as React from "react";

export function ScoringBadge({ scoring }: { scoring?: string | null }) {
    if (!scoring) return null;
    const isHigher = scoring.toLowerCase().includes("higher");
    const isLower = scoring.toLowerCase().includes("lower");
    if (!isHigher && !isLower) return null;
    return (
        <span
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-md font-semibold text-[0.8rem] shadow-sm border ${
                isHigher
                    ? "bg-green-100 text-green-800 border-green-200"
                    : "bg-yellow-100 text-yellow-800 border-yellow-200"
            }`}
        >
            {isHigher
                ? <ArrowUp className="w-4 h-4" />
                : <ArrowDown className="w-4 h-4" />}
            <span>{isHigher ? "Higher is better" : "Lower is better"}</span>
        </span>
    );
}
